import React, { useState } from 'react';
import AdminLayout from 'components/layout/AdminLayout';
import Header from 'components/layout/Partials/Header';
import Section from 'components/UI/Section';
import { Box, Button } from '@material-ui/core';
import FormRenderer from 'lib/FormBuilder/components/FormRenderer';
import createUserFormFields from 'components/settings/Users/Create/createUserFormFields';
import * as yup from 'yup';
import config from 'coeus.config';
import api from 'api';
import { showSnackbar } from 'redux/alerts/actions';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { defaultStyles } from 'utils/Theme';

const validationSchema = {
    name: yup
        .string('Enter your Name')
        .min(2, 'Name should be of minimum 2 characters length')
        .required('Name is required'),
    email: yup
        .string('Enter your email')
        .email('Enter a valid email')
        .required('Email is required'),
    password: yup
        .string('Enter your password')
        .matches(
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{12,}$/,
            'Must Contain 12 Characters, One Uppercase, One Lowercase, One Number and one special case Character'
        )
        .required('Password is required'),
    confirm_password: yup
        .string()
        .required('Confirm Password is a required field')
        .oneOf([yup.ref('password'), null], 'Passwords must match'),
    directory: yup.string().required('User directory is required'),
    qsId: yup.string().required('Qlik Sense User Id is required'),
};

const initialValues = {
    name: '',
    email: '',
    qsId: '',
    directory: '',
    phone: '',
    role: 'User',
};

const CreateUser = () => {
    const { custom_fields: fields } = config.user;
    const formFields = createUserFormFields();
    const dispatch = useDispatch();
    const history = useHistory();
    const classes = defaultStyles();

    const buildErrorMessage = ({ data }) => {
        return Object.values(data).reduce(
            (acc, val) => acc.concat(' ', val),
            ''
        );
    };

    const createUser = (data, setSubmitting) => {
        api.users
            .create(data)
            .then(() => {
                setSubmitting(false);
                dispatch(
                    showSnackbar({
                        severity: 'success',
                        message: 'User Created Successfully',
                    })
                );
                history.push('settings/users');
            })
            .catch((err) => {
                setSubmitting(false);
                const message =
                    err.status === 400
                        ? buildErrorMessage(err)
                        : 'Failed to Create User';
                dispatch(
                    showSnackbar({
                        severity: 'Error',
                        message,
                    })
                );
                console.error(err);
            });
    };

    return (
        <AdminLayout>
            <div className="o-page ">
                <Header>
                    <h2 className="c-navbar__title">Create User</h2>
                </Header>
                <div className="u-m-xsmall">
                    <Section>
                        <Box className="u-p-small full_heights">
                            <div
                                className="o-line"
                                style={{ marginBottom: '10px' }}
                            >
                                <h3
                                    className={`${classes.secondaryColor} u-text-capitalize u-pt-zero u-mt-zero u-pb-small`}
                                >
                                    Create New User
                                </h3>
                                <Button
                                    className={`c-btn ${classes.buttonSecondary}`}
                                    onClick={() => {
                                        this.props.history.goBack();
                                    }}
                                >
                                    Cancel
                                </Button>
                            </div>
                            {formFields && initialValues && (
                                <FormRenderer
                                    formFields={[...formFields, ...fields]}
                                    validationSchema={validationSchema}
                                    submit={createUser}
                                    submitText="Create User"
                                    initialValues={initialValues}
                                />
                            )}
                        </Box>
                    </Section>
                </div>
            </div>
        </AdminLayout>
    );
};

export default CreateUser;
